import api from './api';

export const login = async (credentials) => {
  const res = await api.post('/auth/login', credentials);

  const { accessToken, refreshToken } = res.data;

  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);

  return { accessToken, refreshToken };
};

// Función para validar el token de acceso
export const validateToken = async () => {
  return api.get('/auth/protected');
};

// Función para refrescar el access token
export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');

  if (!refreshToken) {
    return null;
  }

  try {
    const res = await api.post('/auth/refresh', { refreshToken });
    const { accessToken, refreshToken: newRefreshToken } = res.data;

    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', newRefreshToken);

    return accessToken;
  } catch (error) {
    console.error('Error refreshing token:', error);
    return null;
  }
};
